The event types of webhook subscriptions to retrieve.

See `Event` implementations for a list of supported values.

If this is not provided then events of all types will be returned.
